var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"25px 0px","min-height":"500px","background-color":"#fff"}},[(_vm.url)?_c('iframe',{attrs:{"name":"iframe","src":_vm.url,"id":"test","frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }